__turbopack_context__.v({
  "bottom-section": "style-module-scss-module__w7twVW__bottom-section",
  "bottom-text": "style-module-scss-module__w7twVW__bottom-text",
  "component": "style-module-scss-module__w7twVW__component",
  "down-arrow": "style-module-scss-module__w7twVW__down-arrow",
  "jumpInfinite": "style-module-scss-module__w7twVW__jumpInfinite",
  "top-text": "style-module-scss-module__w7twVW__top-text",
});
